import { CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST } from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

type ContractProgressCheckboxFieldsRequiredIdsState = string[];

const initialState: ContractProgressCheckboxFieldsRequiredIdsState = [];

export default function reducer(
  state: ContractProgressCheckboxFieldsRequiredIdsState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
      return initialState;
    default:
      return state;
  }
}
